import React, { useState } from "react";

// ✅ Import images from assets
import villa1 from "../assets/villa1.jpg";
import villa2 from "../assets/villa2.jpg";
import outdoorkitchenkitchen from "../assets/outdoorkitchen.png";
import garage from "../assets/garage.png";
import livingroom from "../assets/livingroom1.png";
import garden from "../assets/park.png";
import kitchen from "../assets/kitcheninterior.png";
import floorplan from "../assets/plan-big.png";

const BigVilla = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { src: villa1, alt: "Big Villa Exterior" },
    { src: villa2, alt: "Medium Villa" },
    { src: outdoorkitchenkitchen, alt: "Outdoor Kitchen" },
    { src: garage, alt: "Garage" },
    { src: livingroom, alt: "Spacious Living Room" },
    { src: garden, alt: "Garden & Outdoor" },
    { src: kitchen, alt: "Modern Kitchen" },
  ];

  return (
    <div className="big-villa-page">
      {/* Hero Section */}
      <header
        className="villa-hero"
        style={{
          backgroundImage: `url(${villa1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
          }}
        ></div>

        {/* Hero Text */}
        <h1 style={{ fontSize: "3.5rem", fontWeight: "700", zIndex: 2 }}>
          Big Villa
        </h1>
        <p
          style={{
            fontSize: "1.3rem",
            marginTop: "1rem",
            maxWidth: "800px",
            zIndex: 2,
            lineHeight: "1.7",
          }}
        >
          The Big Villa is a luxurious two-story residence designed with
          elegance, modern comfort, and private amenities for your family.
        </p>

        {/* Luxury Price Rectangle (No background) */}
        <div
          style={{
            marginTop: "2.5rem",
            padding: "1.2rem 3rem",
            borderRadius: "12px",
            border: "2px solid white",
            color: "white",
            fontSize: "1.6rem",
            fontWeight: "600",
            letterSpacing: "0.5px",
            zIndex: 2,
            display: "inline-block",
            backdropFilter: "blur(3px)",
          }}
        >
          Starting from <span style={{ fontWeight: "600" }}>₼750,000</span>
        </div>
      </header>

      {/* About Section */}
      <section className="villa-about">
        <h2>About the Big Villa</h2>
        <p className="villa-subtext">
          The Big Villa features 450 m² across two floors with 4 bedrooms, 3
          bathrooms, a private pool, landscaped gardens, and a garage. Every
          corner is designed to combine elegance with comfort, making it the
          perfect home for luxury living.
        </p>
        <div className="villa-about-grid">
          <div className="about-card">
            <h3>🏡 Spacious Living</h3>
            <p>
              <span className="about-intro">
                Designed for comfort and functionality, every corner of the Big
                Villa is crafted to elevate everyday living.
              </span>
              <br />
              <br />- <b>450 m² </b> 2-floored <b>White Box villa</b> in a 700
              m² area <br />- Fully <b>repaired exterior</b> including facade,
              roof, walls, windows, doors, and two terraces <br />- Wide yard{" "}
              <b>paved with stones</b> <br />- Dedicated <b>water reservoir</b>{" "}
              <br />- <b>Utility services</b>: water, gas, electricity counters{" "}
              <br />
            </p>
          </div>

          <div className="about-card">
            <h3>✨ Premium Lifestyle</h3>
            <p>
              <span className="about-intro">
                A seamless blend of luxury and leisure designed for
                unforgettable family moments.
              </span>
              <br />
              <br />- Dedicated <b>Barbecue</b> zone <br />- Private <b>pool</b>{" "}
              <br />- <b>Chill-out zone</b> for relaxation <br />- 50 m²{" "}
              <b>outdoor kitchen</b> <br />- Landscaped <b>garden</b> with{" "}
              <b>trees</b> and <b>flowers</b> <br />
            </p>
          </div>

          <div className="about-card">
            <h3>🔒 Smart & Secure</h3>
            <p>
              <span className="about-intro">
                Experience complete peace of mind with intelligent systems and
                24/7 protection.
              </span>
              <br />
              <br />- <b>Secure garage</b> for parking <br />- <b>Smart home</b>{" "}
              system <br />- 24/7 gated community <b>security</b> <br />
            </p>
          </div>
        </div>
        <p className="villa-subtext">
          *Customers can request interior repairs and customization for an
          additional fee.
        </p>
      </section>

      {/* Floor Plan Section */}
      <section className="villa-floor">
        <h2>Floor Plan</h2>
        <div className="villa-floor-text">
          <p>
            The Big Villa’s floor plan is carefully designed to maximize natural
            light, open spaces, and family convenience while ensuring privacy
            and elegance.
          </p>
        </div>
        <div className="floor-wrapper">
          <img src={floorplan} alt="Big Villa Floor Plan" />
        </div>
      </section>

      {/* Gallery Section */}
      <section id="villa-gallery">
        <h2>Villa Gallery</h2>
        <div className="gallery-grid">
          {images.map((img, i) => (
            <div key={i} className={`gallery-item item-${i + 1}`}>
              <img
                src={img.src}
                alt={img.alt}
                onClick={() => setSelectedImage(img.src)}
              />
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div className="lightbox" onClick={() => setSelectedImage(null)}>
            <img src={selectedImage} alt="Enlarged view" />
          </div>
        )}
      </section>
    </div>
  );
};

export default BigVilla;
